
<template>
  <wtFormRight>
    <!-- -TOOLBARS -->
    <template slot="toolbars">
      <Toolbars
        :objProps="objItem"
        :objPropsData="objItemData"
        :urlServices="urlServices"
        :primary_key="primary_key"
        :nameObjData="nameObjData"
        :requiredEndDt="requiredEndDt"
        :noDelete="noDelete"
      />
    </template>

    <!-- VIEW TABLE -->
    <template slot="table" v-if="showGrid">
      <SchedulerGrid @selectedScheduler="objRowSelected = $event"></SchedulerGrid>
    </template>

    <!-- VIEW FORM -->
    <template slot="form" v-if="!showGrid">
      <b-form class="text-uppercase">
        <!-- Line 01 -->
        <div class="form-row">
          <div class="form-group col-md-9">
            <label for="scheduler_description">Description</label>
            <input
              type="text"
              class="form-control"
              id="scheduler_description"
              v-model.trim="objItemData.description"
            />
          </div>
          <div class="form-group col-md-3">
            <label for="scheduler_hour">Hour</label>
            <input
              type="time"
              class="form-control"
              id="scheduler_hour"
              v-model.trim="objItemData.hour"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-12 px-0 mb-0">
            <div class="wt-multiselect">
              <b-form-group label="DAY OF WEEK:" class="mb-0">
                <b-form-checkbox-group
                  id="scheduler-day-of-week"
                  v-model="selected_day_of_week"
                  :options="options_day_of_week"
                  name="options_day_of_week"
                  class="wt-multiselect-item"
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
        </div>

        <!-- Line 02 -->
        <div class="form-row">
          <div class="form-group col-lg-6 px-0">
            <div class="wt-multiselect">
              <b-form-group label="DAY OF MONTH:" class="mb-0">
                <b-form-checkbox-group
                  id="scheduler-day-of-month"
                  v-model="selected_day_of_month"
                  :options="options_day_of_month"
                  name="options_day_of_month"
                  class="wt-multiselect-item"
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
          <div class="form-group col-lg-6 px-0">
            <div class="wt-multiselect">
              <b-form-group label="MONTH:" class="mb-0">
                <b-form-checkbox-group
                  id="scheduler-month"
                  v-model="selected_month"
                  :options="options_month"
                  name="options_month"
                  class="wt-multiselect-item"
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
        </div>

        <!-- Line 03 -->
        <div class="form-row">
          <div class="form-group col-md-2">
            <!-- INTEGER -->
            <label for="scheduler_interval">Interval</label>
            <input
              type="number"
              step="1"
              class="form-control"
              id="scheduler_interval"
              v-model.trim="objItemData.interval"
            />
          </div>
          <div class="form-group col-md-5">
            <!-- TIME STAMP -->
            <label for="scheduler_start_date">Start Date</label>
            <input
              type="date"
              class="form-control"
              id="scheduler_start_date"
              v-model.trim="objItemData.start_date"
            />
          </div>
          <div class="form-group col-md-5">
            <!-- TIME STAMP -->
            <label for="scheduler_end_date">End Date</label>
            <input
              type="date"
              class="form-control"
              id="scheduler_end_date"
              v-model.trim="objItemData.end_date"
            />
          </div>
        </div>

        <!-- Line 04 -->
        <div class="form-row">
          <div class="form-group col-lg-4 col-md-12">
            <label for="scheduler_class_name">Class Name</label>
            <input
              type="text"
              class="form-control"
              id="scheduler_class_name"
              v-model.trim="objItemData.class_name"
            />
          </div>
          <div class="form-group col-lg-4 col-md-6">
            <label for="scheduler_method">Method</label>
            <input
              type="text"
              class="form-control"
              id="scheduler_method"
              v-model.trim="objItemData.method"
            />
          </div>
          <div class="form-group col-lg-4 col-md-6">
            <label for="scheduler_method_param">Method Param</label>
            <input
              type="text"
              class="form-control"
              id="scheduler_method_param"
              v-model.trim="objItemData.method_param"
            />
          </div>
        </div>

        <!-- Line 05 -->
        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="endpoint_method">Endpoint</label>
            <input
              type="text"
              class="form-control"
              id="endpoint_method"
              v-model.trim="objItemData.endpoint"
            />
          </div>

          <div class="form-group col-md-8">
            <label for="queue_queue_description">QUEUE ID</label>
            <QueueFind @queueFind="queueFind=$event" :getQueue="queueFind" :urlOrigem="urlServices"></QueueFind>
          </div>
        </div>
      </b-form>
    </template>
  </wtFormRight>
</template>
<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/* COMPONENTS - LAYOUT */
import wtFormRight from "@/components/forms/wtFormRight";
import Toolbars from "@/components/widgets/Toolbars";

/* COMPONENTS - PAGE */
import SchedulerGrid from "./SchedulerGrid";
import QueueFind from "@/modules/streamline_ds/internal/queue/QueueFind";

export default {
  name: "Scheduler",

  /* COMPONENTS IN USE */
  components: { wtFormRight, Toolbars, SchedulerGrid, QueueFind },

  /* COMPUTED VARIABLES */
  computed: {
    showGrid() {
      return this.$store.state.layout.showGrid;
    },
    urlServicesStore() {
      return this.$store.state.urlServicesStore;
    },
    objShared() {
      return this.$store.state.objShared;
    },
    objSelected() {
      return this.$store.state.objSelected;
    },
    action() {
      return this.$store.state.action;
    }
  },

  /* VARIABLES */
  data: function() {
    return {
      /* Controls */
      urlServices: "streamline-ds/api/internal/scheduler",
      primary_key: "scheduler_id",

      /* Objects Page */
      objItem: {},
      objItemData: {},
      objRowSelected: {},
      nameObjData: "scheduler_data",
      requiredEndDt: true,
      noDelete: true,

      /* Others Query */
      selected_day_of_week: [],
      selected_month: [],
      selected_day_of_month: [],
      options_day_of_week: [
        { text: "Sunday", value: "1" },
        { text: "Monday", value: "2" },
        { text: "Tuesday", value: "3" },
        { text: "Wednesday", value: "4" },
        { text: "Thursday", value: "5" },
        { text: "Friday", value: "6" },
        { text: "Saturday", value: "7" }
      ],
      options_month: [
        { text: "January", value: "1" },
        { text: "February", value: "2" },
        { text: "March", value: "3" },
        { text: "April", value: "4" },
        { text: "May", value: "5" },
        { text: "June", value: "6" },
        { text: "July", value: "7" },
        { text: "August", value: "8" },
        { text: "September", value: "9" },
        { text: "October", value: "10" },
        { text: "November", value: "11" },
        { text: "December", value: "12" }
      ],
      options_day_of_month: [
        { text: "01", value: "1" },
        { text: "02", value: "2" },
        { text: "03", value: "3" },
        { text: "04", value: "4" },
        { text: "05", value: "5" },
        { text: "06", value: "6" },
        { text: "07", value: "7" },
        { text: "08", value: "8" },
        { text: "09", value: "9" },
        { text: "10", value: "10" },
        { text: "11", value: "11" },
        { text: "12", value: "12" },
        { text: "13", value: "13" },
        { text: "14", value: "14" },
        { text: "15", value: "15" },
        { text: "16", value: "16" },
        { text: "17", value: "17" },
        { text: "18", value: "18" },
        { text: "19", value: "19" },
        { text: "20", value: "20" },
        { text: "21", value: "21" },
        { text: "22", value: "22" },
        { text: "23", value: "23" },
        { text: "24", value: "24" },
        { text: "25", value: "25" },
        { text: "26", value: "26" },
        { text: "27", value: "27" },
        { text: "28", value: "28" },
        { text: "29", value: "29" },
        { text: "30", value: "30" },
        { text: "31", value: "31" }
      ],
      queueFind: {}
    };
  },

  /* METHODS */
  methods: {
    load(objItem) {
      this.$store.commit("setShowLoading", true);
      this.$store.commit("setShowGrid", false);

      const param = {};
      param[`${this.primary_key}`] = objItem[`${this.primary_key}`];
      const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find/`;

      axios.post(url, param).then(res => {
        this.objItem = res.data[0];
        this.objItemData = this.objItem[`${this.nameObjData}`];
        this.getQueue();
        this.$store.commit("setShowLoading", false);
      });
    },

    getQueue() {
      const queue = {};
      queue.queue_id = this.objItemData.queue_id;

      const url = `${baseApiUrl}:${baseApiPort}/streamline-ds/api/internal/queue/find`;
      axios.post(url, queue).then(res => {
        this.queueFind = res.data[0];
      });
    },

    isEmpty(obj) {
      for (let x in obj) {
        return false;
      }
      return true;
    }
  },

  /* WATCH */
  watch: {
    objRowSelected() {
      this.load(this.objRowSelected);
      this.$store.commit("setAction", "modify");
    },
    objSelected() {
      if (this.urlServicesStore === this.urlServices) {
        if (Object.entries(this.objSelected).length === 0) {
          this.$emit("securityCredentialSelected", null);
        } else {
          this.$emit("securityCredentialSelected", this.objSelected.access_key);
        }
      }
    },
    action() {
      if (this.urlServicesStore === this.urlServices) {
        if (this.action === "reset") {
          this.objItem = {};
          this.objItemData = {};
        }
      }
    },

    /* CALENDAR DAY OF WEEK, MONTH SYNC */
    selected_day_of_week() {
      if (!this.isEmpty(this.selected_day_of_week)) {
        this.objItemData.day_of_week = this.selected_day_of_week.join(",");
      } else {
        if (!this.isEmpty(this.objItemData)) {
          this.objItemData.day_of_week = "";
        }
      }
    },
    selected_day_of_month() {
      if (!this.isEmpty(this.selected_day_of_month)) {
        this.objItemData.day_of_month = this.selected_day_of_month.join(",");
      } else {
        if (!this.isEmpty(this.objItemData)) {
          this.objItemData.day_of_month = "";
        }
      }
    },
    selected_month() {
      if (!this.isEmpty(this.selected_month)) {
        this.objItemData.month = this.selected_month.join(",");
      } else {
        if (!this.isEmpty(this.objItemData)) {
          this.objItemData.month = "";
        }
      }
    },
    objItemData() {
      if (!this.isEmpty(this.objItemData)) {
        if (!this.isEmpty(this.objItemData.day_of_week)) {
          this.selected_day_of_week = this.objItemData.day_of_week.split(",");
        }
        if (!this.isEmpty(this.objItemData.day_of_month)) {
          this.selected_day_of_month = this.objItemData.day_of_month.split(",");
        }
        if (!this.isEmpty(this.objItemData.month)) {
          this.selected_month = this.objItemData.month.split(",");
        }
      } else {
        this.selected_day_of_week = [];
        this.selected_day_of_month = [];
        this.selected_month = [];
      }
    },

    queueFind() {
      this.objItemData.queue_id = this.queueFind.queue_id;
    }
  }
};
</script>